module.exports = __webpack_public_path__ + "img/user-cog.a8641095.svg";